.DiceFace {
  width: 1em;
  height: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
  padding: 0.1em;
  box-shadow: inset 0 0.05em white, inset 0 -0.05em #bbb, inset 0.05em 0 #d7d7d7, inset -0.05em 0 #d7d7d7;
  border-radius: 10%;
  transform-origin: center;
  background-color: #e7e7e7;
  font-family: var(--header-font);
}
.DiceFace[element=fire] {
  background-color: #d54b33;
}
.DiceFace[element=earth] {
  background-color: #62C370;
}
.DiceFace[element=water] {
  background-color: #639bff;
}
.DiceFace .Icon {
  width: 95%;
  height: 95%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  image-rendering: smooth;
}
.DiceFace .SmallNumeral {
  font-size: 0.5em;
  line-height: 1em;
  position: absolute;
  bottom: 0.05em;
  right: 0.2em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
